/**
 * @generated SignedSource<<a5eb12e00e1aa6f8e29d8bd0797b70c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ItemPickerMilestoneRelayMilestone$data = {
  readonly closed: boolean;
  readonly closedAt: string | null | undefined;
  readonly dueOn: string | null | undefined;
  readonly id: string;
  readonly progressPercentage: number;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "ItemPickerMilestoneRelayMilestone";
};
export type ItemPickerMilestoneRelayMilestone$key = {
  readonly " $data"?: ItemPickerMilestoneRelayMilestone$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemPickerMilestoneRelayMilestone">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ItemPickerMilestoneRelayMilestone"
};

(node as any).hash = "214a79225fa8eed1160ff28cba790de3";

export default node;
